import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Avatar from "../components/Avatar";

export default function Profile() {
  const { user, completeProfile, updateProfile, changePassword } = useAuth();

  const [firstName, setFirstName] = useState(user?.firstName || "");
  const [lastName, setLastName] = useState(user?.lastName || "");
  const [email, setEmail] = useState(user?.email || "");

  const [firstPassword, setFirstPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const isFirstTime = !!user?.mustCompleteProfile;

  useEffect(() => {
    setFirstName(user?.firstName || "");
    setLastName(user?.lastName || "");
    setEmail(user?.email || "");
  }, [user]);

  const handleSaveFirstTime = async () => {
    if (!firstName.trim() || !lastName.trim()) {
      alert("Förnamn och efternamn är obligatoriskt");
      return;
    }
    if (firstPassword.length < 8) {
      alert("Lösenord måste vara minst 8 tecken");
      return;
    }
    await completeProfile({
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      newPassword: firstPassword,
    });
    alert("Profil klar!");
  };

  const handleUpdateProfile = async () => {
    if (!firstName.trim() || !lastName.trim()) {
      alert("Förnamn och efternamn är obligatoriskt");
      return;
    }
    await updateProfile({ firstName: firstName.trim(), lastName: lastName.trim(), email });
    alert("Profil uppdaterad");
  };

  const handleChangePassword = async () => {
    if (newPassword.length < 8) {
      alert("Nytt lösenord måste vara minst 8 tecken");
      return;
    }
    await changePassword({ currentPassword, newPassword });
    setCurrentPassword("");
    setNewPassword("");
    alert("Lösenord uppdaterat");
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 560 }}>
      <h3 className="mb-3">Min profil</h3>

      {user && (
        <div className="mb-3 d-flex align-items-center gap-2">
          <Avatar
            initials={user?.avatar?.initials}
            color={user?.avatar?.color}
            size={42}
            title={`${user.firstName || ""} ${user.lastName || ""}`.trim()}
          />
          <div className="small text-muted">
            Avatarfärgen är låst till kontot. Initialer uppdateras när ditt namn ändras.
          </div>
        </div>
      )}

      <div className="mb-3">
        <label className="form-label">Förnamn</label>
        <input className="form-control" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="form-label">Efternamn</label>
        <input className="form-control" value={lastName} onChange={(e) => setLastName(e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="form-label">E-post</label>
        <input className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
      </div>

      {isFirstTime ? (
        <>
          <div className="mb-3">
            <label className="form-label">Välj nytt lösenord (minst 8 tecken)</label>
            <input
              type="password"
              className="form-control"
              value={firstPassword}
              onChange={(e) => setFirstPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <button className="btn btn-success" onClick={handleSaveFirstTime}>
            Slutför profil
          </button>
        </>
      ) : (
        <>
          <button className="btn btn-primary mb-4" onClick={handleUpdateProfile}>
            Spara profil
          </button>

          <h5>Byt lösenord</h5>
          <div className="mb-3">
            <label className="form-label">Nuvarande lösenord</label>
            <input
              type="password"
              className="form-control"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Nytt lösenord (minst 8 tecken)</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <button className="btn btn-outline-secondary" onClick={handleChangePassword}>
            Uppdatera lösenord
          </button>
        </>
      )}
    </div>
  );
}
